import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import PropTypes from 'prop-types';
import parseAttributes from 'parse-attributes';
import decamelize from 'decamelize'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import mapKeys from 'lodash/mapKeys'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pick from 'lodash/pick'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import toString from 'lodash/toString';
import { CCProductImpression, ProductImpression } from '@nerdwallet/nw-client-lib/tracking';
export var prepLinkData = function prepLinkData(linkData) {
  if (_typeof(linkData) === 'object') {
    return linkData;
  } // Input: "dataOne='uno' dataTwo='dos'"
  // Output {"data-one": "uno", "data-two": "dos"}


  var attrs = parseAttributes(linkData);
  return mapKeys(attrs, function (value, key) {
    return decamelize(key, '-');
  });
};
export var getCCImpressionProps = function getCCImpressionProps(_ref) {
  var filterState = _ref.filterState,
      props = _objectWithoutProperties(_ref, ["filterState"]);

  var linkData = prepLinkData(props.link_data);
  var impressionProps = {
    id: toString(props.id),
    issuer: props.issuer,
    pageNumber: props.pageNumber,
    productPosition: props.productPosition,
    productLocation: props.productLocation,
    productInstance: props.productInstance,
    sectionPosition: props.sectionPosition,
    productId: toString(props.productId || linkData['data-cid']),
    productSlug: props.productSlug || linkData['data-cname'],
    linkType: props.linkType || linkData['data-link-type'],
    offerVersionId: toString(props.offerVersionId || linkData['data-offer-version-id'])
  };

  if (filterState) {
    impressionProps.cardNetworkFilter = filterState.cardNetworkFilter;
    impressionProps.creditScoreFilter = filterState.creditScoreFilter;
    impressionProps.feesFilter = filterState.feesFilter;
    impressionProps.financialInstitutionsFilter = filterState.financialInstitutionsFilter;
    impressionProps.monthlySpendFilter = filterState.monthlySpendFilter;
    impressionProps.yearsWithCardFilter = filterState.yearsWithCardFilter;
  }

  return impressionProps;
};

var getProductImpressionProps = function getProductImpressionProps(props) {
  return _objectSpread(_objectSpread({}, pick(props, Object.keys(ProductImpression.propTypes))), {}, {
    id: toString(props.id),
    productId: toString(props.productId)
  });
};

var ApplyNowImpression = function ApplyNowImpression() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Allow consumer to opt out of logging impression, particularly useful for testing as the impression is a container component
  if (!props.logImpression) {
    return props.children;
  }

  return props.isCC ? /*#__PURE__*/React.createElement(CCProductImpression, getCCImpressionProps(props), props.children) : /*#__PURE__*/React.createElement(ProductImpression, getProductImpressionProps(props), props.children);
};

ApplyNowImpression.displayName = 'ApplyNowImpression';
ApplyNowImpression.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  // Unique id for the impression on this page
  isCC: PropTypes.bool,
  link_data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  issuer: PropTypes.string,
  filterState: PropTypes.shape({
    // The filter state is captured in impressions on the credit card tool
    cardNetworkFilter: PropTypes.string,
    creditScoreFilter: PropTypes.string,
    feesFilter: PropTypes.string,
    financialInstitutionsFilter: PropTypes.string,
    monthlySpendFilter: PropTypes.number,
    yearsWithCardFilter: PropTypes.number
  }),
  pageNumber: PropTypes.number,
  productPosition: PropTypes.number,
  productLocation: PropTypes.string,
  productInstance: PropTypes.string,
  sectionPosition: PropTypes.number,
  offerVersionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  productSlug: PropTypes.string,
  linkType: PropTypes.string,
  logImpression: PropTypes.bool,
  children: PropTypes.element.isRequired
};
export default ApplyNowImpression;